
import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface IDialogInfo {
    isOpen: boolean,
    content: string,
    info: any,
    title: string | null
}

export const initialValueDialog: IDialogInfo = {
    isOpen: false,
    content: '',
    info: {},
    title: null
}

const setDialogParams = createSlice({
    name: 'SET_PARAMS_DIALOG',
    initialState: initialValueDialog,

    reducers: {
        setDialogInfo: (state, {payload}) => (state = payload),
        setCloseDialog: (state) => (state = initialValueDialog)
    }

})

export const {setDialogInfo, setCloseDialog} = setDialogParams.actions;

//EXPORT SELECTOR FOR CHILD
export const InfoDialog = (state: RootState) => state.setDialogParams
export default setDialogParams.reducer